export enum EnrollmentSearchOption {
    Off = 'Off',
    On = 'On',
    WebOnly = 'WebOnly',
    MobileOnly = 'MobileOnly'
}
